module.exports = __webpack_public_path__ + "static/media/sophisticated-thumbnail.f5877c90.png";